"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCy = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Chip = _interopRequireDefault(require("../Chip"));
var _TextField = _interopRequireDefault(require("../TextField"));
var _Autocomplete = _interopRequireDefault(require("@mui/material/Autocomplete"));
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _styles = require("@mui/styles");
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["label", "placeholder", "variant", "renderTagsProp", "freeSolo", "clearOnBlur", "blurOnSelect", "defaultValue", "value", "name", "onSearch", "onChange", "getOptionValue", "getOptionLabel", "createOption", "error", "helper", "onFocus", "plainValue", "isTagRemovable", "required"],
  _excluded2 = ["InputProps", "inputProps"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    input: {
      boxSizing: 'border-box',
      minHeight: '38px'
    }
  };
});
var dataCy = exports.dataCy = 'ChipsInput';
var EMPTY_VALUE = [];
var defaultGetOptionLabel = function defaultGetOptionLabel(option) {
  return option.name;
};
var defaultGetOptionValue = function defaultGetOptionValue(option) {
  return option.id;
};
var defaultCreateOption = function defaultCreateOption(inputValue) {
  return {
    name: inputValue
  };
};
var ChipsInput = function ChipsInput(_ref) {
  var label = _ref.label,
    placeholder = _ref.placeholder,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'outlined' : _ref$variant,
    renderTagsProp = _ref.renderTagsProp,
    freeSolo = _ref.freeSolo,
    _ref$clearOnBlur = _ref.clearOnBlur,
    clearOnBlur = _ref$clearOnBlur === void 0 ? false : _ref$clearOnBlur,
    blurOnSelect = _ref.blurOnSelect,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? EMPTY_VALUE : _ref$defaultValue,
    _ref$value = _ref.value,
    valueProp = _ref$value === void 0 ? EMPTY_VALUE : _ref$value,
    name = _ref.name,
    onSearch = _ref.onSearch,
    onChange = _ref.onChange,
    _ref$getOptionValue = _ref.getOptionValue,
    getOptionValue = _ref$getOptionValue === void 0 ? defaultGetOptionValue : _ref$getOptionValue,
    _ref$getOptionLabel = _ref.getOptionLabel,
    getOptionLabel = _ref$getOptionLabel === void 0 ? defaultGetOptionLabel : _ref$getOptionLabel,
    _ref$createOption = _ref.createOption,
    createOption = _ref$createOption === void 0 ? defaultCreateOption : _ref$createOption,
    error = _ref.error,
    helper = _ref.helper,
    onFocus = _ref.onFocus,
    _ref$plainValue = _ref.plainValue,
    plainValue = _ref$plainValue === void 0 ? false : _ref$plainValue,
    _ref$isTagRemovable = _ref.isTagRemovable,
    isTagRemovable = _ref$isTagRemovable === void 0 ? function () {
      return true;
    } : _ref$isTagRemovable,
    required = _ref.required,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    options = _useState4[0],
    setOptions = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isOpen = _useState6[0],
    setIsOpen = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    loading = _useState8[0],
    setLoading = _useState8[1];
  var value = (0, _react.useMemo)(function () {
    return plainValue ? valueProp.map(createOption) : valueProp;
  }, [valueProp, plainValue, createOption]);
  var handleChange = (0, _react.useCallback)(function (e, value, reason) {
    var newValue = null;
    if (reason === 'createOption') {
      newValue = [].concat(_toConsumableArray(value.slice(0, value.length - 1)), [createOption(value[value.length - 1])]);
    } else {
      newValue = value;
    }
    onChange(e, plainValue ? newValue.map(getOptionLabel) : newValue);
    if (reason === 'selectOption') {
      setInputValue('');
      setOptions([]);
    }
  }, [onChange, setInputValue, setOptions, plainValue]);
  var handleInputChange = function handleInputChange(_e, value) {
    setInputValue(value);
    if (value && onSearch) {
      setIsOpen(true);
      setLoading(true);
      setOptions([]);
      onSearch({
        search: value
      }).then(function (searchResult) {
        setOptions(searchResult);
      })["finally"](function () {
        setLoading(false);
      });
    }
  };
  var handleFocus = function handleFocus() {
    if (inputValue) {
      setIsOpen(true);
    }
    onFocus && onFocus();
  };
  var handleBlur = function handleBlur() {
    setIsOpen(false);
  };
  var getOptionSelected = (0, _react.useCallback)(function (option, valueOption) {
    var optValue = getOptionValue(option);
    var valueOptValue = getOptionValue(valueOption);
    if (optValue === undefined) {
      // new option without value
      return false;
    }
    return optValue === valueOptValue;
  }, [getOptionValue]);
  var renderTags = function renderTags(tags, _getTagProps) {
    var getTagProps = function getTagProps(params) {
      var index = params === null || params === void 0 ? void 0 : params.index;
      var tag = tags && tags[index];
      var label = (0, _lodash.camelCase)(getOptionLabel(tag));
      var removable = isTagRemovable(tag);
      return _objectSpread(_objectSpread({}, _getTagProps(params)), {}, {
        'data-cy-label': label,
        removable: removable
      });
    };
    if (renderTagsProp) {
      return renderTagsProp(tags, getTagProps);
    } else {
      return tags.map(function (option, index) {
        return /*#__PURE__*/(0, _react.createElement)(_Chip["default"], _objectSpread(_objectSpread({
          label: getOptionLabel(option)
        }, getTagProps({
          index: index,
          option: option
        })), {}, {
          key: index
        }));
      });
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Autocomplete["default"], _objectSpread({
    renderTags: renderTags,
    multiple: true,
    disableClearable: true,
    popupIcon: false,
    freeSolo: freeSolo,
    clearOnBlur: clearOnBlur,
    blurOnSelect: blurOnSelect,
    options: options,
    getOptionLabel: getOptionLabel,
    isOptionEqualToValue: getOptionSelected,
    defaultValue: defaultValue,
    value: value,
    loading: loading,
    noOptionsText: "No states matching \"".concat(inputValue, "\" were found"),
    open: Boolean(inputValue && isOpen),
    onChange: handleChange,
    filterOptions: function filterOptions(options) {
      return options;
    },
    classes: classes,
    "data-cy": dataCy,
    "data-cy-label": name,
    renderOption: function renderOption(p, option) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", _objectSpread(_objectSpread({}, p), {}, {
        "data-cy": "select-option-".concat((0, _lodash.camelCase)(option.name)),
        children: getOptionLabel(option)
      }));
    },
    renderInput: function renderInput(_ref2) {
      var _ref2$InputProps = _ref2.InputProps,
        InputProps = _ref2$InputProps === void 0 ? {} : _ref2$InputProps,
        _ref2$inputProps = _ref2.inputProps,
        inputProps = _ref2$inputProps === void 0 ? {} : _ref2$inputProps,
        params = _objectWithoutProperties(_ref2, _excluded2);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField["default"], _objectSpread(_objectSpread({}, params), {}, {
        variant: variant,
        label: label,
        InputProps: _objectSpread(_objectSpread({}, InputProps), {}, {
          style: _objectSpread({}, InputProps.style),
          endAdornment: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react["default"].Fragment, {
            children: [loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_CircularProgress["default"], {
              color: 'inherit',
              size: 20
            }) : null, InputProps.endAdornment]
          })
        }),
        inputProps: inputProps,
        debounceTimeout: 300,
        affix: InputProps.startAdornment,
        value: inputProps.value,
        onChange: handleInputChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        placeholder: placeholder,
        required: required,
        error: error,
        helper: helper,
        "data-cy-role": 'searchInput'
      }));
    }
  }, props));
};
ChipsInput.propTypes = {
  defaultValue: _propTypes["default"].array,
  value: _propTypes["default"].array,
  name: _propTypes["default"].string,
  freeSolo: _propTypes["default"].bool,
  clearOnBlur: _propTypes["default"].bool,
  blurOnSelect: _propTypes["default"].bool,
  plainValue: _propTypes["default"].bool,
  getOptionValue: _propTypes["default"].func,
  getOptionLabel: _propTypes["default"].func,
  createOption: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onSearch: _propTypes["default"].func,
  renderTagsProp: _propTypes["default"].func,
  /**
   * The variant to use.
   */
  variant: _propTypes["default"].oneOf(['filled', 'outlined', 'standard']),
  isTagRemovable: _propTypes["default"].func,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired
};
var _default = exports["default"] = ChipsInput;